import React from 'react'

export default function Footer() {
    return (
        <footer className="uk-text-center" style={{margin:"1vh", fontFamily:"Crimson Text", padding:"14vh" }}>
            <p>Sujay &copy; {new Date().getFullYear()}</p>
        </footer>
    )
}
